import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible/flexible'
import { Button,Uploader,Toast, Field } from 'vant'
import axios from './utils/axios' // axios 实例


Vue.config.productionTip = false

Vue.prototype.$axios = axios

Vue.use(Button).use(Uploader).use(Toast).use(Field)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
